import { useState } from "react";
import { FaShieldAlt } from "react-icons/fa";
import Button from "../controls/button/button";
import TextField from "../controls/text-field/text-field";
import { strengthScore } from "../ui-helpers";
import './password.css';

/**
 * Password change component.
 * @param {ReactDOM.props} props Component properties.
 * @returns Generated component.
 */
const Password = (props) => {

    // Initialize states
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [valid, setValid] = useState(false);

    /**
     * Checks whether password is valid.
     * @returns True if password is valid, False otherwise.
     */
    const isValid = () => {

        // Get elements
        const strength = document.getElementById('strength');
        const passEl = document.getElementById('new-password');
        const confirmEl = document.getElementById('password-confirm');
        const password = passEl.value;
        const confirm = confirmEl.value;

        // Check score
        const score = strengthScore(password);
        if (score > 80) {
            strength.classList.remove('critical');
            strength.classList.remove('warning');
            strength.classList.add('ok');
            strength.innerText = 'Mot de passe sécurisé';
        }
        else if (score > 60) {
            strength.classList.remove('critical');
            strength.classList.add('warning');
            strength.classList.remove('ok');
            strength.innerText = 'Mot de passe acceptable';
        }
        else {
            strength.classList.add('critical');
            strength.classList.remove('warning');
            strength.classList.remove('ok');
            strength.innerText = 'Mot de passe trop faible';
        }

        // Return result
        return password === confirm && score > 60;
    }

    /**
     * Validate handler.
     */
    const validate = () => {
        const passEl = document.getElementById('new-password');
        props?.onValidate?.(passEl.value);
    }

    const handlePasswordChange = (value) => {
        setPassword(value);
        setValid(isValid());
    }

    const handleConfirmChange = (value) => {
        setConfirm(value);
        setValid(isValid());
    }

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            paddingTop: '68px',
            paddingLeft: '68px',
            gap: 0,
        }}>
        <div style={{ width: '100%', maxWidth: 360 }}>
            <div style={{ color: '#64748b', fontSize: 14, marginBottom: 16 }}>
                <div style={{ marginBottom: 6 }}>Votre mot de passe doit contenir au moins :</div>
                <ul style={{ margin: 0, paddingLeft: 20, lineHeight: '1.8' }}>
                    <li>12 caractères</li>
                    <li>Une lettre en minuscule</li>
                    <li>Une lettre en majuscule</li>
                    <li>Un chiffre</li>
                    <li>Un caractère de ponctuation</li>
                </ul>
            </div>
            <TextField
                id='new-password'
                label='Mot de passe'
                dataType='string'
                placeholder="Mot de passe"
                value={password}
                onChange={(evt) => { handlePasswordChange(evt.target.value) }}
                onKeyUp={(evt) => { handlePasswordChange(evt.target.value) }}
                password
                large
            />
            <div id="strength" className="critical" style={{ margin: '10px 0 18px 0' }}>Mot de passe trop faible</div>
            <TextField
                id='password-confirm'
                label='Confirmation'
                dataType='string'
                placeholder="Confirmation"
                value={confirm}
                onChange={(evt) => { handleConfirmChange(evt.target.value) }}
                onKeyUp={(evt) => { handleConfirmChange(evt.target.value) }}
                password
                large
            />
            <Button
                onClick={validate}
                disabled={!valid}
                large
                style={{ marginTop: 28, width: '100%' }}
            >
                Enregistrer
                <FaShieldAlt />
            </Button>
        </div>
        </div>
    )
}
export default Password;